import React, { FC } from 'react';
import { FormattedNumber } from 'react-intl';
import color from '../../config/color';
import { AssetWithCalculatedStats } from '../../interfaces/interfaces';

interface Props {
  isSummary: boolean;
  assets: AssetWithCalculatedStats[];
}

const PortfolioTotal: FC<Props> = ({ isSummary, assets }) => {
  /*
    This component calculates and shows summarized totals for all equities.
  */

  let totalPrice = 0;
  let totalValue = 0;
  let totalChangeSinceYesterday = 0;
  let totalValueYesterday = 0;

  if (!assets.length) {
    return null;
  }

  assets.forEach(asset => {
    const assetTotalValue = asset.price * asset.stockholding;
    const percentChangeSinceYesterday = (asset.percentChange + 100) / 100;
    const valueYesterday = assetTotalValue / percentChangeSinceYesterday;

    totalPrice += asset.totalPrice;
    totalValue += assetTotalValue;
    totalValueYesterday += valueYesterday;
    totalChangeSinceYesterday += assetTotalValue - valueYesterday;
  });

  return (
    <tr className="equity-row" style={{ fontWeight: 600 }}>
      <td>Totalt</td>
      <td className={isSummary ? 'hide-on-650px' : 'hide-on-991px'}>
        <FormattedNumber
          minimumFractionDigits={0}
          maximumFractionDigits={0}
          value={totalPrice}
        />
      </td>
      <td className="hide-on-350px hide-on-summary" />
      <td className={isSummary ? 'hide-on-350px' : 'hide-on-650px'} />
      <td className={color.getClassName(totalChangeSinceYesterday)}>
        <FormattedNumber // eslint-disable-next-line
          style="percent"
          minimumFractionDigits={2}
          maximumFractionDigits={2}
          value={totalChangeSinceYesterday / totalValueYesterday}
        />
      </td>
      <td className={isSummary ? 'hide-on-500px' : 'hide-on-500px'} />
      <td className="hide-on-374px">
        <FormattedNumber
          minimumFractionDigits={0}
          maximumFractionDigits={0}
          value={totalValue - totalPrice}
        />
      </td>
      <td
        className={`${color.getClassName(totalValue - totalPrice)} ${
          isSummary ? 'hide-on-580px' : 'hide-on-740px'
        }`}
      >
        <FormattedNumber // eslint-disable-next-line
          style="percent"
          minimumFractionDigits={2}
          maximumFractionDigits={2}
          value={(totalValue - totalPrice) / totalPrice}
        />
      </td>
      <td className="hide-on-580px hide-on-summary" />
      <td>
        <FormattedNumber
          minimumFractionDigits={0}
          maximumFractionDigits={0}
          value={totalValue}
        />
      </td>
    </tr>
  );
};

export default PortfolioTotal;
